import React from "react";
import { Modal, Button } from "reactstrap";
import "./AuthorSelection.css";

function AuthorSelection(props) {
  return (
    <Modal
      className="modal-dialog-centered modal-sm"
      isOpen={props.operationNewModal}
      toggle={() => props.toggleNewModal()}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => props.toggleNewModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body d-flex flex-column justify-content-center align-items-center">
        {/* {props.sub.errorMsg} */}
        <label className="form-control-label">選擇分類</label>
        <div
          className="mb-3"
          style={{
            border: "1px solid",
            borderColor: "#cccccc",
            borderRadius: "4px",
          }}
        >
          <div className="d-flex justify-content-around py-4">
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <label className="form-control-label">新聞管理</label>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-2"
                  id="check-2"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(2) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={2}
                />
                <label className="custom-control-label" htmlFor="check-2">
                  今日要聞
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-3"
                  id="check-3"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(3) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={3}
                />
                <label className="custom-control-label" htmlFor="check-3">
                  國際新聞
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-5"
                  id="check-5"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(5) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={5}
                />
                <label className="custom-control-label" htmlFor="check-5">
                  地方新聞
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-4"
                  id="check-4"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(4) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={4}
                />
                <label className="custom-control-label" htmlFor="check-4">
                  僑社新聞
                </label>
              </div>

              <label className="form-control-label  mt-1">活動管理</label>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-102"
                  id="check-102"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(102) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={102}
                />
                <label className="custom-control-label" htmlFor="check-102">
                  春節遊園會
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-103"
                  id="check-103"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(103) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={103}
                />
                <label className="custom-control-label" htmlFor="check-103">
                  麥當勞教育展
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-104"
                  id="check-104"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(104) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={104}
                />
                <label className="custom-control-label" htmlFor="check-104">
                  其他活動
                </label>
              </div>

              <label className="form-control-label  mt-1">商業</label>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-106"
                  id="check-106"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(106) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={106}
                />
                <label className="custom-control-label" htmlFor="check-106">
                  促銷活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-107"
                  id="check-107"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(107) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={107}
                />
                <label className="custom-control-label" htmlFor="check-107">
                  商家信息
                </label>
              </div>
            </div>

            <div className="px-2 py-1" style={{ flex: 1 }}>
              <label className="form-control-label">生活資訊</label>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-109"
                  id="check-109"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(109) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={109}
                />
                <label className="custom-control-label" htmlFor="check-109">
                  美食
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-110"
                  id="check-110"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(110) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={110}
                />
                <label className="custom-control-label" htmlFor="check-110">
                  房地產
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-111"
                  id="check-111"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(111) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={111}
                />
                <label className="custom-control-label" htmlFor="check-111">
                  健康養生
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-112"
                  id="check-112"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(112) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={112}
                />
                <label className="custom-control-label" htmlFor="check-112">
                  娛樂
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-113"
                  id="check-113"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(113) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={113}
                />
                <label className="custom-control-label" htmlFor="check-113">
                  旅遊
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-159"
                  id="check-159"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(159) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={159}
                />
                <label className="custom-control-label" htmlFor="check-159">
                  體育
                </label>
              </div>
              <label className="form-control-label  mt-1">美南廣場</label>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-115"
                  id="check-115"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(115) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={115}
                />
                <label className="custom-control-label" htmlFor="check-115">
                  美南投資
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-116"
                  id="check-116"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(116) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={116}
                />
                <label className="custom-control-label" htmlFor="check-116">
                  美南地產
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-123"
                  id="check-123"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(123) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={123}
                />
                <label className="custom-control-label" htmlFor="check-123">
                  董事長介紹
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => props.toggleNewModal()}
          >
            取消
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => props.submitArticle()}
          >
            新建文章
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AuthorSelection;
